<h4>Êtes-vous sûr de vouloir supprimer ce trip ?</h4>
<h5>Trip Id : {{data.tripId}}</h5><br/>
<ion-row>
    <ion-button color="light" (click)="close()">Cancel</ion-button>
    <ion-button color="danger" (click)="deleteTrip()">Delete</ion-button>
</ion-row>
